function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import Slider from "react-slick";
import ActiveTitle from "@common/components/ActiveTitle";
import ShowBigger from "@common/components/show-bigger/ShowBigger";
import Show from "@common/components/show/Show";
import VodCard from "@common/components/vod-card/VodCard";
import { secondsToMilliseconds } from "@common/services/helpers";
import { BREAKPOINTS } from "@common/services/responsive";
import { CATEGORIES_ICONS_CONFIG, LAST_WATCHED, SLIDER_ICON_MIN_WIDTH, SLIDER_SPEED, VOD } from "@config/constants";
import NextArrow from "./NextArrow";
import PrevArrow from "./PrevArrow";
var ShowsSlider = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ShowsSlider, PureComponent);
    var _super = _create_super(ShowsSlider);
    function ShowsSlider(props) {
        _class_call_check(this, ShowsSlider);
        var _this;
        _this = _super.call(this, props);
        _this.type = props.type || null;
        _this.direction = "";
        _this.initialNumberOfShows = _this.props.shows.length;
        _this.numberOfSlidesToShow = 7;
        _this.slider = null;
        _this.shouldHaveLiveLabel = _this.shouldHaveLiveLabel.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(ShowsSlider, [
        {
            /**
     * Checks if the show is currently live
     * and if it can have the 'live' label
     * @param showLiveLabel {boolean}
     * @param show {object}
     * @returns {*|boolean}
     */ key: "shouldHaveLiveLabel",
            value: function shouldHaveLiveLabel(showLiveLabel, show) {
                var currentTimestamp = new Date().getTime();
                var isNow = show.now || currentTimestamp >= secondsToMilliseconds(show.start) && currentTimestamp < secondsToMilliseconds(show.stop);
                return showLiveLabel && isNow;
            }
        },
        {
            /**
     * Renders the slider with its props.
     * @returns {ReactElement}
     */ key: "renderSlider",
            value: function renderSlider() {
                var _this = this;
                var _this_props = this.props, category = _this_props.category, channel = _this_props.channel, channelsLogos = _this_props.channelsLogos, className = _this_props.className, closePlayer = _this_props.closePlayer, currentDate = _this_props.currentDate, currentWatchedEpg = _this_props.currentWatchedEpg, darkerThumbnail = _this_props.darkerThumbnail, hasLogo = _this_props.hasLogo, hasStaticTitle = _this_props.hasStaticTitle, hasTitle = _this_props.hasTitle, hasTitleByDate = _this_props.hasTitleByDate, hasSideIcon = _this_props.hasSideIcon, hasSmallerFont = _this_props.hasSmallerFont, hideOpenEpgs = _this_props.hideOpenEpgs, hideOpenEpgsOnPlay = _this_props.hideOpenEpgsOnPlay, history = _this_props.history, i18n = _this_props.i18n, isCardBig = _this_props.isCardBig, isCardWithoutHeader = _this_props.isCardWithoutHeader, isInPlayer = _this_props.isInPlayer, level = _this_props.level, parentCategoryId = _this_props.parentCategoryId, route = _this_props.route, showCategories = _this_props.showCategories, showHasLabel = _this_props.showHasLabel, showLiveLabel = _this_props.showLiveLabel, shows = _this_props.shows, staticLink = _this_props.staticLink, staticLinkTitle = _this_props.staticLinkTitle, timestamp = _this_props.timestamp, videoPlayerWrapper = _this_props.videoPlayerWrapper;
                var slider = null;
                if (_to_consumable_array(shows).length === 0) {
                    return null;
                }
                if (Array.isArray(shows)) {
                    var innerWidth = window.innerWidth;
                    if (innerWidth <= BREAKPOINTS.s) {
                        this.numberOfSlidesToShow = 2;
                    } else if (innerWidth <= BREAKPOINTS.m) {
                        this.numberOfSlidesToShow = 3;
                    } else if (innerWidth <= BREAKPOINTS.l) {
                        this.numberOfSlidesToShow = 4;
                    } else if (innerWidth <= BREAKPOINTS.xl) {
                        this.numberOfSlidesToShow = 5;
                    } else if (innerWidth <= BREAKPOINTS.xxl) {
                        this.numberOfSlidesToShow = 6;
                    } else {
                        this.numberOfSlidesToShow = 7;
                    }
                    if (isCardBig) {
                        this.numberOfSlidesToShow = this.numberOfSlidesToShow - 1;
                    }
                    var aligningClass = shows.length < this.numberOfSlidesToShow ? " align-to-left" : "";
                    var slidesToRender = _to_consumable_array(shows.map(function(show) {
                        var componentProps = {
                            logo: channelsLogos ? channelsLogos[show.chanId] : null,
                            i18n: i18n,
                            hasLogo: hasLogo,
                            history: history,
                            isInPlayer: isInPlayer,
                            showHasLabel: showHasLabel,
                            showCategories: showCategories,
                            key: "".concat(show.title, "-").concat(show.start, "-").concat(show.stop, "-").concat(show.chanId),
                            videoPlayerWrapper: videoPlayerWrapper,
                            closePlayer: closePlayer,
                            isOpenEpgsList: _this.props.isOpenEpgsList,
                            darkerThumbnail: darkerThumbnail,
                            currentWatchedEpg: currentWatchedEpg,
                            show: show,
                            hideOpenEpgsOnPlay: hideOpenEpgsOnPlay,
                            hideOpenEpgs: hideOpenEpgs,
                            isCardWithoutHeader: isCardWithoutHeader,
                            showLiveLabel: _this.shouldHaveLiveLabel(showLiveLabel, show),
                            type: _this.type,
                            photos: show.photos
                        };
                        if (_this.type === VOD) return /*#__PURE__*/ _jsx(VodCard, _object_spread({}, componentProps));
                        return isCardBig ? /*#__PURE__*/ _jsx(ShowBigger, _object_spread({}, componentProps)) : /*#__PURE__*/ _jsx(Show, _object_spread({}, componentProps));
                    }));
                    var uniqueSliderClass = "category-slider category-".concat(category.id).concat(aligningClass);
                    var sideIcon = null;
                    // Generates the side icon if it's indicated to has one
                    if (hasSideIcon && isCardBig && window.innerWidth >= SLIDER_ICON_MIN_WIDTH) {
                        var iconSpecifics = CATEGORIES_ICONS_CONFIG[category.id] || CATEGORIES_ICONS_CONFIG[0];
                        sideIcon = /*#__PURE__*/ _jsx("span", {
                            className: "".concat(iconSpecifics.iconClass, " slider-icon")
                        });
                    }
                    if (!isCardBig && route === LAST_WATCHED) {
                        // fullWidthBackground = <div className="slider-full-width-background"></div>;
                        uniqueSliderClass += " slider-full-width-background";
                    }
                    var numberOfSlides = isCardBig ? 6 : 8;
                    var settings = {
                        lazyLoad: isInPlayer,
                        infinite: false,
                        nextArrow: /*#__PURE__*/ _jsx(NextArrow, {}),
                        prevArrow: /*#__PURE__*/ _jsx(PrevArrow, {}),
                        speed: SLIDER_SPEED,
                        slidesToShow: numberOfSlides,
                        slidesToScroll: numberOfSlides,
                        responsive: [
                            {
                                breakpoint: BREAKPOINTS.xxl,
                                settings: {
                                    slidesToShow: isCardBig ? 5 : 6,
                                    slidesToScroll: isCardBig ? 5 : 6
                                }
                            },
                            {
                                breakpoint: BREAKPOINTS.xl,
                                settings: {
                                    slidesToShow: isCardBig ? 4 : 5,
                                    slidesToScroll: isCardBig ? 4 : 5
                                }
                            },
                            {
                                breakpoint: BREAKPOINTS.l,
                                settings: {
                                    slidesToShow: isCardBig ? 3 : 4,
                                    slidesToScroll: isCardBig ? 3 : 4
                                }
                            },
                            {
                                breakpoint: BREAKPOINTS.m,
                                settings: {
                                    slidesToShow: isCardBig ? 2 : 3,
                                    slidesToScroll: isCardBig ? 2 : 3
                                }
                            },
                            {
                                breakpoint: BREAKPOINTS.s,
                                settings: {
                                    slidesToShow: isCardBig ? 1 : 2,
                                    slidesToScroll: isCardBig ? 1 : 2
                                }
                            }
                        ]
                    };
                    slider = /*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "shows-slider-component ".concat(className ? className : ""),
                            children: [
                                sideIcon,
                                hasTitle && /*#__PURE__*/ _jsx(ActiveTitle, {
                                    category: category,
                                    channel: channel,
                                    i18n: i18n,
                                    isInPlayer: isInPlayer,
                                    initialNumberOfShows: this.initialNumberOfShows,
                                    route: route,
                                    type: this.type,
                                    level: level,
                                    hasSmallerFont: hasSmallerFont,
                                    hasStaticTitle: hasStaticTitle,
                                    staticLink: staticLink,
                                    staticLinkTitle: staticLinkTitle,
                                    hasTitleByDate: hasTitleByDate,
                                    timestamp: timestamp,
                                    currentDate: currentDate,
                                    parentCategoryId: parentCategoryId,
                                    isActive: this.numberOfSlidesToShow < shows.length,
                                    showsPerSlide: this.numberOfSlidesToShow
                                }),
                                /*#__PURE__*/ _jsx(Slider, _object_spread_props(_object_spread({
                                    ref: function(el) {
                                        return _this.slider = el;
                                    },
                                    tabIndex: this.props.tabIndex,
                                    className: uniqueSliderClass
                                }, settings), {
                                    children: slidesToRender.map(function(slide) {
                                        return /*#__PURE__*/ _jsx("div", {
                                            children: slide
                                        }, slide.key);
                                    })
                                }))
                            ]
                        })
                    });
                }
                return slider;
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: this.renderSlider()
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                // This logic is for the player's slider
                // to make the currently watched show visible
                // (in range after the slider is toggled).
                if (this.props.currentWatchedEpg !== undefined && typeof this.props.initialToIndex !== "undefined") {
                    setTimeout(function() {
                        _this.slider.slickGoTo(_this.props.initialToIndex);
                    }, 0);
                }
            }
        }
    ]);
    return ShowsSlider;
}(PureComponent);
export default withRouter(ShowsSlider);
